@for (renewalType of this.renewalTypes$ | async; track renewalType) {
  @if (renewalType.value === 'auto') {
    <ui5-icon name="refresh" data-cy="renewal-icon" aria-hidden="true"></ui5-icon>
    <span class="ms-1" data-cy="renewal-text">{{ 'configurator.date.renewal' | cxTranslate }}</span>
    <dcp-icon-button-tooltip
      data-cy="renewal-tooltip"
      [openOnClick]="true"
      placement="End"
      [attr.accessible-name]="'configurator.date.renewalTooltip' | cxTranslate"
      [attr.aria-label]="'configurator.date.renewalTooltip' | cxTranslate">
      <span class="body--s">{{ 'configurator.date.renewalTooltip' | cxTranslate }}</span>
    </dcp-icon-button-tooltip>
  }
}
